import React from 'react';
import { HeroSection } from './components/HeroSection';
import { EmotionalHook } from './components/EmotionalHook';
import { PatternSection } from './components/PatternSection';
import { WhyNothingWorked } from './components/WhyNothingWorked';
import { GuideSolution } from './components/GuideSolution';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-[#FFF5F7] text-[#4a2535] overflow-x-hidden selection:bg-[#c4607a] selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <EmotionalHook data-id="element-2" />
      <PatternSection data-id="element-3" />
      <WhyNothingWorked data-id="element-4" />
      <GuideSolution data-id="element-5" />
      <FinalCTA data-id="element-6" />
      <Footer data-id="element-7" />
    </main>;
}